import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-order-popup',
    templateUrl: './delete-order-popup.component.html',
    styleUrls: ['./delete-order-popup.component.css'],
    imports: [MatDialogTitle, MatDialogActions]
})
/**
 * A popup that prompts the user to continue deleting the order or cancel.
 */
export class DeleteOrderPopupComponent {
    private dialogRef = inject<MatDialogRef<DeleteOrderPopupComponent>>(MatDialogRef);

    /**
     * Close the popup and indicate the order should not be deleted.
     */
    cancel(): void {
        this.dialogRef.close(false);
    }

    /**
     * Close the popup and indicate the order should be deleted.
     */
    confirm(): void {
        this.dialogRef.close(true);
    }
}
